import {
  Spinner,
  SpinnerProps,
  TableCellProps,
  TableRowProps,
  Td,
  Tr,
} from "@chakra-ui/react";
import { RowData, Table } from "@tanstack/react-table";

export type TableLoadingSpinnerProps<D extends RowData> = SpinnerProps & {
  tableCellProps?: Partial<TableCellProps>;
  tableInstance: Table<D>;
  tableRowProps?: Partial<TableRowProps>;
};

export default function TableLoadingSpinner<D extends RowData>({
  tableCellProps,
  tableInstance,
  tableRowProps,
  ...rest
}: TableLoadingSpinnerProps<D>) {
  return (
    <Tr {...tableRowProps}>
      <Td
        colSpan={tableInstance.getVisibleLeafColumns().length}
        textAlign="center"
        p={8}
        className="scroll-container-centered"
        {...tableCellProps}
      >
        <Spinner size="xl" color="gray.500" {...rest} />
      </Td>
    </Tr>
  );
}
